module.exports = __webpack_public_path__ + "img/contur-focus-red.06ef2146.svg";